// ATE-CR-159
import { Link } from "react-router-dom";
import { Mail, Settings } from "lucide-react";

import { ROUTE_NOTIFICATIONS_VERIFICATIONS } from "@/constants/routes";

import "./SystemConfigPage.css";

// ATE-CR-159
interface SystemConfigItem {
  readonly title: string;
  readonly description: string;
  readonly to: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly icon: React.ComponentType<any>;
}

// ATE-CR-159: System Config sub-items. Pass 2 amendment placed Verify Email
// here rather than as a top-level NAV_HQ entry.
const SYSTEM_CONFIG_ITEMS: readonly SystemConfigItem[] = [
  {
    title: "Verify Email",
    description:
      "Send a test email through the production notification pipeline and watch each stage land in Cloud Trace. Helps detect silent-drop failures before organic traffic does.",
    to: ROUTE_NOTIFICATIONS_VERIFICATIONS,
    icon: Mail,
  },
];

// ATE-CR-159
export function SystemConfigPage(): JSX.Element {
  return (
    <section className="system-config-page">
      <header className="system-config-page__header">
        <div className="system-config-page__header-icon">
          <Settings size={24} aria-hidden="true" />
        </div>
        <div>
          <h1 className="system-config-page__title">System Config</h1>
          <p className="system-config-page__subtitle">
            Operator-level configuration tools.
          </p>
        </div>
      </header>

      <ul className="system-config-page__list" aria-label="System Config sections">
        {SYSTEM_CONFIG_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <li key={item.to} className="system-config-page__item">
              <Link
                to={item.to}
                className="system-config-page__link"
                aria-label={`Open ${item.title}`}
              >
                <span className="system-config-page__link-icon">
                  <Icon size={20} aria-hidden="true" />
                </span>
                <span className="system-config-page__link-body">
                  <span className="system-config-page__link-title">{item.title}</span>
                  <span className="system-config-page__link-description">
                    {item.description}
                  </span>
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
